import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "un-recharge-modal-content" }
const _hoisted_2 = { class: "un-recharge-modal-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/icon/warning_icon.png",
  alt: "",
  class: "warning"
}, null, -1)
const _hoisted_4 = { class: "un-recharge-modal-body" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "text-tip" }
const _hoisted_7 = { class: "un-recharge-modal-footer" }

import { useRtfix } from '@/store'
import { useRouter } from 'vue-router'
import { t } from '@/plugins/i18n'
import { ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const router = useRouter()
const dialogVisible = ref(false)
let timer:any = null
const close = () => {
  dialogVisible.value = false
}
const closeFn = () => {
  console.log('关闭')
  clearTimeout(timer)
}
const jump = () => {
  clearTimeout(timer)
  router.push(useRtfix('CustomerFund'))
}
expose({
  open: () => {
    dialogVisible.value = true
    timer = setTimeout(() => {
      router.push(useRtfix('CustomerFund'))
    }, 5000)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
    title: "Tips",
    "custom-class": "un-recharge-modal-2",
    "show-close": false,
    onClose: closeFn
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_unref(t)('下单失败3')), 1),
          _createElementVNode("img", {
            src: "https://static-s.theckb.com/BusinessMarket/Client/icon/close_icon.png",
            alt: "",
            class: "close",
            onClick: close
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('您的余额不足，请充值后再次支付')), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('5s后跳转充值页面')), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "btn-cancel",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/')))
          }, _toDisplayString(_unref(t)('回到首页')), 1),
          _createElementVNode("div", {
            class: "btn-submit",
            onClick: jump
          }, _toDisplayString(_unref(t)('去充值2')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})